<template>
  <div class="liveshow-radio">
    <RadioGroup  v-model="selectModel" >
      <Radio v-for="(item, index) in selectOptions" :label="index + 1"  :key="item.value">{{ item.label }}</Radio>
    </RadioGroup>
    <div v-if="[2, 5].includes(selectModel)" class="radioSwitch">
      <span class="ml-1">{{ '双赔' }}：</span>
      <i-switch size="large" v-model="isDoubleOdds" true-value="0" false-value="1">
        <span slot="open">{{ '连动' }}</span>
        <span slot="close">{{ '不连动' }}</span>
      </i-switch>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      selectOptions: [
        {
          value: 9,
          label: "二全中"
        },
        {
          value: 10,
          label: "二中特"
        },
        {
          value: 12,
          label: "二特串"
        },
        {
          value: 13,
          label: "三全中"
        },
        {
          value: 14,
          label: "三中二 "
        }
      ]
    };
  },
  computed: {
      ...mapGetters(['getliveshow']),
    selectModel: {
      get() {
        return this.getliveshow.proj;
      },
      set(val) {
        const value = this.selectOptions[val - 1]
        this.chg_liveshow_state({ title: value.label, dobuecode: value.value, proj: val });
        this.upDate_reload()
      }
    },
    isDoubleOdds: {
      get() {
        return this.getliveshow.isdoubleOdds
      },
      set(val) {
        this.upDate_isdoubleOdds(val)
      }
    }
  },
  created () {
    this.changeState()
  },
  methods: {
      ...mapActions(["chg_liveshow_state", 'upDate_reload', 'upDate_isdoubleOdds']),
    changeState () { 
      const value = this.selectOptions[0]
      this.chg_liveshow_state({ title: value.label, dobuecode: value.value, proj: 1 });
      this.upDate_reload()
    }
  }
};
</script>

<style lang="scss">
.radioSwitch {
  display: inline-flex;
  align-content: center;
  .ivu-switch-large {
    width: 75px;
    &.ivu-switch-checked {
      .ivu-switch-inner {
        left: 20px;
      }
    }
    &.ivu-switch-checked:after {
      left: 54px;
    }
  }

}
</style>